import { appControlSliderInit } from '../../../snippets/app-control-slider/app-control-slider';

window.onReady(() => {
  appControlSliderInit();
});
